import { Parameters } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classnames from 'classnames';
import { useState } from 'react';

import { PopupMenu } from '../_DEPRECATED/PopupMenu';
import { Button } from '../Button/Button';

import styles from './Kanban.module.scss';
import { Props } from './Kanban.types';

export const Kanban = ({ title, className, children, filterPopupContent, height }: Props) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.title}>{title}</p>
        {filterPopupContent && (
          <PopupMenu
            children={filterPopupContent}
            onOpen={() => setIsFilterOpen(true)}
            onClose={() => {
              setIsFilterOpen(false);
            }}
            trigger={
              <Button
                variant="tertiary"
                className={classnames(styles.trigger, { [styles.activeTrigger]: isFilterOpen })}
              >
                <Parameters />
              </Button>
            }
            position="left top"
          />
        )}
      </div>
      <div className={classnames(styles.kanbanContainer, className)} style={{ height: height }}>
        <div className={styles.fullWidth}>
          <div className={styles.scrollableComponent}>{children}</div>
        </div>
      </div>
    </div>
  );
};
